import { Button, Tooltip } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { FormControl, InputGroup, Modal } from "react-bootstrap";
import { useOrderTrackingInfo, useValidWarehouse } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { required } from "modules/utilities/utility";
// import customerContext from "Context/CostumerContext";

function MarkShipped({
  order,
  currentWarehouse,
  selectedWarehouse,
  trackingURL,
  trackingID,
  parentClose,
}) {
  const [trackingId, setTrackingId] = useState(order.tracking_id);
  const [trackingUrl, setTrackingUrl] = useState(order.tracking_url);
  const [show, setShow] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState();
  const [tooltip, setTooltip] = useState("");

  const { markShipped } = useValidWarehouse();
  const { setToaster } = useToast();
  const { fetchOrderTrackingInfo, orderTrackingInfo } = useOrderTrackingInfo();

  useEffect(() => {
    fetchOrderTrackingInfo(order.id);
  }, [order.id]);

  useEffect(() => {
    setTrackingUrl(
      orderTrackingInfo.trackingUrl || trackingURL || order.tracking_url || ""
    );
    setTrackingId(
      orderTrackingInfo.trackingId || trackingID || order.tracking_id || ""
    );
  }, [trackingID, trackingURL, orderTrackingInfo]);

  useEffect(() => {
    if (["delivered", "shipped"].includes(order.status)) {
      setButtonDisabled(true);
      setTooltip(`Order already ${order.status}`);
    } else if (!currentWarehouse) {
      setButtonDisabled(true);
      setTooltip("Warehouse info not updated");
    } else if (currentWarehouse !== selectedWarehouse) {
      setButtonDisabled(true);
      setTooltip("Update the warehouse before mark order shipped");
    } else {
      setButtonDisabled(false);
      setTooltip("Mark order shipped if warehouse info is correct");
    }
  }, [currentWarehouse, order.status, selectedWarehouse]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClick = () => {
    handleShow();
  };

  return (
    <div>
      <Tooltip placement="topLeft" title={tooltip}>
        <Button
          className="ml-2"
          key="continue"
          type="primary"
          disabled={buttonDisabled}
          onClick={handleClick}
        >
          Mark Shipped
        </Button>
      </Tooltip>
      <Modal show={show} onHide={() => handleClose()} style={{ top: "15%" }}>
        <Modal.Header>Warehouse Info</Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1" style={{ width: "12rem" }}>
              Tracking URL {required}
            </InputGroup.Text>
            <FormControl
              required
              placeholder="Username"
              aria-label="Username"
              aria-describedby="basic-addon1"
              defaultValue={trackingUrl}
              onChange={(event) => {
                setTrackingUrl(event.target.value);
              }}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1" style={{ width: "12rem" }}>
              Tracking ID {required}
            </InputGroup.Text>
            <FormControl
              required
              placeholder="Username"
              aria-label="Username"
              aria-describedby="basic-addon1"
              defaultValue={trackingId}
              onChange={(event) => {
                setTrackingId(event.target.value);
              }}
            />
          </InputGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button key="cancel" onClick={() => handleClose()}>
            Cancel
          </Button>
          <Button
            key="submit"
            disabled={!trackingId || !trackingUrl}
            type="primary"
            onClick={() => {
              markShipped(order.id, { trackingId, trackingUrl }, setToaster);
              parentClose();
            }}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default MarkShipped;
